const useFeature = (feature: string) => {
  const enabledFeatures = process.env.REACT_APP_ENABLED_FEATURES || '';
  const featuresArray = enabledFeatures.split(',').map(f => f.trim().toLowerCase());
  return featuresArray.includes(feature.toLowerCase());
};

export default useFeature;
